import { FC, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { BackgroundLabelSlider } from './BackgroundLabelSlider';
import { BackgroundLabelItem } from '../../../../../../services/studio/StudioQuery/BackgroundLabel/BackgroundLabelQuery.services';
import './BackgroundLabelPopover.scss';

interface BackgroundLabelPopoverProps {
    open: boolean;
    anchorEl?: HTMLElement | null;
    onClose: () => void;
    type: 'background' | 'label';
    onSelect: (item: BackgroundLabelItem) => void;
}

export const BackgroundLabelPopover: FC<BackgroundLabelPopoverProps> = ({ open, onClose, type, onSelect }) => {
    const { t } = useTranslation();
    const [selectedId, setSelectedId] = useState<string | null>(null);

    const handleSelect = (item: BackgroundLabelItem) => {
        setSelectedId(item.id);
        onSelect(item);
        // Auto-close after selection
        setTimeout(() => {
            onClose();
            setSelectedId(null);
        }, 300);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: 3,
                        maxHeight: '80vh',
                    },
                },
            }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                <Typography variant="h6" fontWeight="bold">
                    {type === 'background'
                        ? t('mannequin.aiGeneration.popover.selectBackground')
                        : t('mannequin.aiGeneration.popover.selectLabel')}
                </Typography>
                <IconButton size="small" onClick={onClose}>
                    <Close />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ p: 3 }}>
                <BackgroundLabelSlider type={type} onSelect={handleSelect} selectedId={selectedId} />
            </DialogContent>
        </Dialog>
    );
};
